export default __webpack_public_path__ + "static/media/github-square-brands.6af96adb.svg";